/* eslint-disable @typescript-eslint/no-empty-object-type */

export type PagePaginationRequest<T = {}> = {
  page?: number;
  perPage?: number;
} & T;
export type PagePaginationResponse<T> = {
  data: T[];
  meta: {
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
};

export type CursorPaginationRequest<T = {}> = {
  cursor?: string;
  perPage?: number;
} & T;
export type CursorPaginationResponse<T> = {
  data: T[];
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}
